import { requestApi } from '@app/api';
import { withDocument } from '@app/api/paths';
import AllowSignatureTypes from '@app/store/AllowSignatureTypes';
import TextAlign from '@app/store/TextAlign';

import { NewPostDocumentsParams, NewPostDocumentsResponse } from '../../documents';

interface CheckboxField {
  dataLabel: string;
  description: string | null;
  fieldType: string;
  locationPage: number;
  locationX: number;
  locationY: number;
  locationZ: number;
  required: boolean;
  sizeWidth: number | null;
}

export interface SignatureField {
  allowSignatureTypes: AllowSignatureTypes;
  dataLabel: string;
  description: string | null;
  fieldType: string;
  locationPage: number;
  locationX: number;
  locationY: number;
  locationZ: number;
  required: boolean;
}

interface TextField {
  dataLabel: string;
  description: string | null;
  fieldType: string;
  locationPage: number;
  locationX: number;
  locationY: number;
  locationZ: number;
  required: boolean;
  sizeHeight: number | null;
  sizeWidth: number | null;
  textStyleAlign: TextAlign;
  textStyleFontSize: number | null;
  textStyleFontType: string | null;
}

export type Field = CheckboxField | SignatureField | TextField;

interface AuthenticationWithMobile {
  authType: string;
  authValuePhoneNumber: string | null;
  authValueName: string | null;
  authGuidePhoneNumber: string | null;
  authGuideName: string | null;
}

interface AuthenticationWithPassword {
  authType: string;
  authValuePassword: string | null;
}

export type Authentication = AuthenticationWithMobile | AuthenticationWithPassword;
export interface Attachment {
  attachmentType: string;
  message: string | null;
  required: boolean;
}

export interface ParticipantValue {
  attachments: Attachment[];
  authentications: Authentication[];
  contactInfo: string;
  fields: Field[];
  locale?: string;
  messageFromRequester: string | null;
  name: string;
  signingOrder: number;
  signingMethodType: string;
  signingExpiryPeriod: number | null;
}

interface RequesterInputPosition {
  x: number;
  y: number;
  z: number;
  page: number;
}

interface RequesterInputSize {
  width: number;
  height: number;
}

interface RequesterInputTextStyle {
  align: TextAlign;
  fontType: string;
  fontSize: number;
}

export interface RequesterInput {
  checkboxInputChecked: boolean | null;
  dataLabel: string;
  description: string | null;
  inputValueType: string;
  position: RequesterInputPosition;
  size: RequesterInputSize | null;
  textInputContent: string | null;
  textInputTextStyle: RequesterInputTextStyle | null;
}

export function postApiDocuments(workspaceId: string, params: NewPostDocumentsParams) {
  return requestApi<NewPostDocumentsResponse>({
    url: withDocument(`/workspaces/${workspaceId}/api/documents`),
    method: 'POST',
    data: params,
    credentials: true,
  }).then((response) => response.data);
}
